import { List } from 'immutable';

import { UPDATE_CAMPAIGN_SUCCESS } from 'redux/campaign/reducer';
import { mapCampaign } from 'utils/mapToRecord';
import { createSymbols } from 'utils/helpers';
import { collectionReducer } from 'utils/reducerGenerator';


export const { HIDE_CAMPAIGN } = createSymbols(['HIDE_CAMPAIGN']);

const updateCampaignSuccess = (state, { payload }) => {
    const campaignIndex = state.get('data', List([])).findIndex((campaign) => {
        return campaign.get('id') === payload.data.id;
    });

    if (campaignIndex !== -1) {
        return state.set(
            'data',
            state.get('data').set(campaignIndex, mapCampaign(payload.data))
        );
    }

    return state.set(
        'data',
        state.get('data').unshift(mapCampaign(payload.data))
    );
};
const removeCampaignFromList = (state, action) => {
    const remainingCampaigns = state.get('data').filter(
        (item) => item.get('id') !== action.payload.campaignId
    );

    return state.set('data', remainingCampaigns);
};

export const { reducer, types } = collectionReducer({
    namespace: 'CAMPAIGN',
    transformer: mapCampaign,
}, {
    [HIDE_CAMPAIGN]: removeCampaignFromList,
    [UPDATE_CAMPAIGN_SUCCESS]: updateCampaignSuccess,
});

export default reducer;
